module.exports = __webpack_public_path__ + "img/eurotext_logo_optimized.b9f55f42.svg";